import styled, { DefaultTheme } from 'styled-components';
import { T0 } from 'ia-react-core';
// import informationIcon from '../../assets/ic-info-outline.svg';

export const StyledTitle = styled(T0)`
  text-align: center;
  text-shadow: ${({ theme }) => (theme as DefaultTheme & { awAuthentication?: { textShadow?: string } })?.awAuthentication?.textShadow || ''};

  @media only screen and (max-width: 600px)
  {
    font-size: 32px;
  }

  @media only screen and (max-width: 375px)
  {
    font-size: 28px;
  }
`;

export const StyledInstabilityMessages = styled.div`
  max-width: 560px;
  margin: auto;
`;
